import styled from 'styled-components'

export const Overlay = styled.div`
	position: absolute;
	inset: 0;
	background-color: currentColor;
	opacity: 0.2;
`
